export default __webpack_public_path__ + "static/media/bearEmpty.99618161.svg";